export const API_URL = import.meta.env.VITE_API_URL as string;
export const MEDIA_URL = import.meta.env.VITE_MEDIA_URL as string;
export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX as string;
